/**
 * NPS 설문 에러 코드 상수
 * @type {Object.<string, number>}
 */
export const ERROR_CODES = {
	INVALID_ACCESS: 3000,
	INVALID_ACCESS_ALT: 3001,
	ALREADY_RESPONDED: 3002,
	ALREADY_RESPONDED_CSAT: 30021,
	EXPIRED: 3003,
};

export const ERROR_CODE_MESSAGE = {
	[ERROR_CODES.INVALID_ACCESS]: '유효한 접근이 아닙니다.',
	[ERROR_CODES.INVALID_ACCESS_ALT]: '유효한 접근이 아닙니다.',
	[ERROR_CODES.ALREADY_RESPONDED]: '이미 응답한 설문입니다.',
	[ERROR_CODES.ALREADY_RESPONDED_CSAT]: '이미 응답한 설문입니다.',
	[ERROR_CODES.EXPIRED]: '설문이 만료되었습니다.',
	etc: '문제가 발생했습니다.\n잠시 후 다시 시도해 주세요.',
};

export const DEFAULT_EVENT_ID = '1';
export const DEFAULT_TITLE = '서비스 만족도 조사';
export const MAX_LENGTH_INPUT = 300;
export const REASON_TITLE = '위 점수를 준 이유를 알려주세요';
export const PLACEHOLDER_INPUT = '고객님의 의견을 자세히 알려주세요';
export const DEFAULT_SCORE = 5;
export const DEFAULT_MIN_SCALE = 0;
export const DEFAULT_MAX_SCALE = 5;

/** 점수 슬라이더 라벨의 meta 키 */
export const SCALE_LABEL_META_KEYS = {
	MIN: 'scaleMinLabel', // 슬라이더 좌측 라벨
	MAX: 'scaleMaxLabel', // 슬라이더 우측 라벨
	GUIDE: 'scaleLabel', // 슬라이더 하단 안내 문구(점수 미선택 시 노출)
};

/** 슬라이더 하단 안내 문구 기본값 (meta.scaleLabel 미제공 시) */
export const DEFAULT_SCALE_GUIDE_LABEL = '동그라미를 움직여 점수를 선택하세요';

/** 타이틀 노출 여부 meta 키 (값: 'TRUE' | 'FALSE', 쿼리파람 eventPageOptions.showTitle보다 우선) */
export const SHOW_TITLE_META_KEY = 'showTitle';

/** meta 불리언 문자열의 참값 (BE 스펙: 대문자 고정) */
export const META_TRUE = 'TRUE';

export const POLICE_NOTIFY_URL = 'https://m.encar.com/cl/index.do?method=clPoliceNotify';
export const DEFAULT_TYPE = 'SHORT_TEXT';
export const ANSWER_TYPES = {
	SINGLE_CHOICE: 'SINGLE_CHOICE', // 단일 선택(type B)
	MULTIPLE_CHOICE: 'MULTIPLE_CHOICE', // 다중 선택(type C)
	SHORT_TEXT: 'SHORT_TEXT', // 단순 텍스트(type A)
	REFERENCE: 'REFERENCE', // 목록 별도 API 조회(개인화된 데이터)
	ONLY_SCORE: 'ONLY_SCORE', // 점수만 입력(옵션 없음)
	SCORE_CHOICE: 'SCORE_CHOICE', // 점수 구간으로 다음 질문이 갈리는 타입(옵션 UI 없음). CES 설문지에서 사용
};

/**
 * NPS 설문 이벤트 타입 상수
 * @type {Object.<string, string>}
 */
export const EVENT_NAMES = {
	ENQUIRY_RECEIVED_CALL: 'enquiryReceivedCall', // 딜러/엔카 설문지
	MEET_GO_DELIVERY_BUY: 'meetGoDeliveryBuy',
	MEET_GO_DELIVERY_REQUEST: 'meetGoDeliveryRequest',
	ESTIMATE_PRO_SELL: 'estimateProSell',
	ESTIMATE_PRO_REQUEST: 'estimateProRequest',
	ESTIMATE_PLUS_SELL: 'estimatePlusSell',
	ESTIMATE_PLUS_REQUEST: 'estimatePlusRequest',
	ESTIMATE_REQUEST: 'estimateRequest',
	ESTIMATE_SELL: 'estimateSell',
};

export const USER_TYPES = {
	CLIENT: 'CLIENT',
	DIRECT: 'DIRECT',
	REPEAT: 'REPEAT',
	DEALER: 'DEALER',
	EMPLOYEE: 'EMPLOYEE',
};

export const DEFAULT_EVENT_NAME = EVENT_NAMES.ENQUIRY_RECEIVED_CALL;

// 설문 UX타입 상수
export const TEMPLATE_VIEW_TYPE = {
	LIST: 'LIST',
	CARD: 'CARD',
};

/** 설문 meta.terms 상수 (설문 완료 후 추가 동의 절차 구분) */
export const SURVEY_TERMS = {
	INTERVIEW: 'INTERVIEW', // 서비스 개선 인터뷰 참여 의사 확인
};

/** 인터뷰 참여 의사 */
export const INTERVIEW_PARTICIPATION = {
	YES: 'Y',
	NO: 'N',
};

/** CSAT 설문 화면 타입 상수: url query string 파라미터 값이기 때문에 소문자로 정의 */
export const UI_MODE = {
	LAYER: 'layer',
	POPUP: 'popup',
	PAGE: 'page',
};

export const DEFAULT_UI_MODE = UI_MODE.PAGE;

/** SDK에서 전달받는 query string 파라미터 키 */
export const SDK_PARAMS = {
	DELIVERY_KEY: 'deliveryKey',
	MODE: 'mode',
	EVENT_PAGE_OPTIONS: 'eventPageOptions',
	SAVE_PARAMS: 'saveParams',
};

/** v3 페이지로 리다이렉트할 이벤트 목록 (pages/meta 구조 적용된 설문지) */
export const V3_REDIRECT_EVENTS = [
	{
		id: '1',
		subject: 'inquirySatisfaction-1',
		comment: '만족도설문_구매문의_전화',
		eventName: 'enquiryReceivedCall',
		eventType: 'ENQUIRY_RECEIVED',
	},
	{
		id: '2',
		subject: 'inquirySatisfaction-2',
		comment: '만족도설문_구매문의_전화',
		eventName: 'enquiryReceivedCall',
		eventType: 'ENQUIRY_RECEIVED',
	},
	{
		id: '3',
		subject: 'inquirySatisfaction-3',
		comment: '만족도설문_구매문의_전화',
		eventName: 'enquiryReceivedCall',
		eventType: 'ENQUIRY_RECEIVED',
	},
];

/** iframe에서 레이어 닫기 요청 시 보낼 postMessage type */
export const ENCAR_SURVEY_POSTMESSAGE_CLOSE = 'encar-survey-close';

/** iframe에서 레이어 닫기 요청 시 보낼 postMessage message */
export const MESSAGE_FINISH_SUBMIT = 'finishSubmit';
